import { marker } from '@jsverse/transloco-keys-manager/marker';

export const LOADING_MESSAGES = {
  default: marker('loading.default'),
  wait: marker('loading.wait'),
};
